import { StorefrontApiClientError } from './storefrontClient';
import { STOREFRONT_API_STATUS_CODE_MESSAGES } from '../../common/notificationMessages';
import { getFlashMessageType } from '../../common/notificationMessagesHelper';
import FlashMessages from '../../components/ui/FlashMessages';

export const handleStorefrontClientError = (e: Error, defaultError: string = ''): void => {
  if (!(e instanceof StorefrontApiClientError)) {
    return;
  }

  const code = e.statusCode;
  const message =
    code >= 200 && code < 300 ? (e.message ?? defaultError) : getDefaultStatusCodeMessage(code);

  const flashType = code >= 200 && code < 300 && e.message ? 'warn' : getFlashMessageType(code);

  if (flashType) {
    FlashMessages[flashType](message);
  }
};

export const getDefaultStatusCodeMessage = (code: number): string =>
  STOREFRONT_API_STATUS_CODE_MESSAGES[`STATUS_${Math.floor(code / 100) * 100}`] ?? '';
